import "../styles/loader.css";

export default function Loader() {
  return (
    <>
      <div className="ContainerSpiner">
        <div className="spiner">
          <h2>Beto , Loading ...</h2>
        </div>
      </div>
    </>
  );
}
